import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Pergunta, uma de cada vez, se cada alteração feita no Tipo 1 deve ser
// aplicada aos restantes diplomas (com referência ligada).
export function DiplomaReferencePrompt({ queue, index, onAnswer }) {
  const q = queue[index];
  if (!q) return null;
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-md" data-testid="ref-prompt-dialog">
        <DialogHeader>
          <DialogTitle className="text-base">Aplicar aos restantes diplomas?</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-700" data-testid="ref-prompt-text">
          Deseja aplicar aos restantes diplomas (com "Definições de referência" ligadas) a alteração feita{" "}
          {q.kind === "structure" ? "na lista de campos (campo adicionado/removido)" : <>no <b>campo {q.index + 1}</b> (<span className="font-mono">{q.label}</span>)</>}?
        </p>
        <p className="text-[11px] text-slate-500">Pergunta {index + 1} de {queue.length}</p>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" onClick={() => onAnswer(false)} data-testid="ref-prompt-no">Não</Button>
          <Button className="bg-slate-900" onClick={() => onAnswer(true)} data-testid="ref-prompt-yes">Sim</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
